module.exports = __webpack_public_path__ + "img/image19@3x.992ecc40.png";